import { FC, useMemo } from "react";

import { groupBy } from "@/lib/groupBy";

import { useGetPriorityListForWorkspace } from "../hooks/api/use-get-priority-list-for-workspace";
import { ALLOWED_PRIORITY_LIST } from "../models/priority-type";

import { PrioritySettingsTableSection } from "./priority-settings-table-section";

export interface PrioritySettingsTableProps {
  workspaceId: string;
  hasEditPermission?: boolean;
}

export const PrioritySettingsTable: FC<PrioritySettingsTableProps> = ({ workspaceId, hasEditPermission }) => {
  const { priorityList } = useGetPriorityListForWorkspace({ workspaceId: workspaceId });

  const groupedPriorityList = useMemo(() => {
    return groupBy(priorityList, (priority) => priority.type);
  }, [priorityList]);

  if (!priorityList) {
    return <></>;
  }

  return (
    <>
      {ALLOWED_PRIORITY_LIST.map((type) => {
        const priorityForType = groupedPriorityList.get(type) ?? [];
        return (
          <PrioritySettingsTableSection
            key={type}
            workspaceId={workspaceId}
            priorityType={type}
            priorityList={priorityForType}
            className="mb-4"
            hasEditPermission={hasEditPermission}
          />
        );
      })}
    </>
  );
};
